export default __webpack_public_path__ + "87fe7e2f9005750ed8181cf5f928cf00.gltf";